// extracted by mini-css-extract-plugin
export var closed = "_7v-1";
export var resizer = "_7v-0";